import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

type Props = {config: ConfigObjectType};
export const ReportsAMRLayoutContainer: React.FC<Props> = (props) => {
  return <>TODO</>;
};
